import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
// Registries deep-link state lives in the URL so a reload, a pasted link and
// the browser Back button all land where the user was:
//   record=<id>  the open record's drawer — opening PUSHES a history entry
//   q=<text>     the tab's search filter — typing REPLACES (no entry per key)
// Closing a record replaces too, so Back from a closed drawer leaves the page
// rather than re-opening it.
export function useRegistryRecord() {
    const [params, setParams] = useSearchParams();
    const recordId = params.get('record');
    const openRecord = useCallback((id)=>setParams((prev)=>{
            const next = new URLSearchParams(prev);
            next.set('record', id);
            return next;
        }), [
        setParams
    ]);
    const closeRecord = useCallback(()=>setParams((prev)=>{
            const next = new URLSearchParams(prev);
            next.delete('record');
            return next;
        }, {
            replace: true
        }), [
        setParams
    ]);
    return {
        recordId,
        openRecord,
        closeRecord
    };
}
export function useRegistryQuery() {
    const [params, setParams] = useSearchParams();
    const q = params.get('q') ?? '';
    const setQ = useCallback((next)=>setParams((prev)=>{
            const p = new URLSearchParams(prev);
            if (next) p.set('q', next);
            else p.delete('q');
            return p;
        }, {
            replace: true
        }), [
        setParams
    ]);
    return [
        q,
        setQ
    ];
}
